module.exports = __webpack_public_path__ + "img/set.d8ff611c.png";